import { TimeblocksByRangeWithGeoQuery } from "@chef/state-management";
import { isEmptyArray } from "@chef/utils/array";
import { formatTimeInterval, isNightTimeDelivery } from "@chef/helpers";
import { Checkbox } from "@chef/components";

import { intl } from "./ChangeFirstDeliveryDateModal.Intl";

interface SelectDeliveryTimeProps {
  timeblocks: TimeblocksByRangeWithGeoQuery["timeblocksByRangeWithGeo"]["weeks"][number]["timeblocks"];
  selectedTimeblockId: number;
  onChange: (value: number) => void;
}
export const SelectDeliveryTime = ({
  timeblocks,
  selectedTimeblockId,
  onChange,
}: SelectDeliveryTimeProps) => {
  if (isEmptyArray(timeblocks)) {
    return (
      <div className="mt-2 mb-4 text-sm text-center text-error">
        {intl.NO_DELIVERY_ON_SELECTED_ADDRESS_FOR_THIS_WEEK}
      </div>
    );
  }

  const sortedTimeblocks = [...timeblocks].sort((a, b) =>
    a.from.localeCompare(b.from),
  );

  const hasNightTimeDelivery = isNightTimeDelivery(
    timeblocks.find((t) => t.timeblockId === selectedTimeblockId),
  );

  return (
    <div className="w-full mb-8">
      <div className="mb-3 mr-auto text-sm">
        <strong>{intl.CHOOSE_TIME}</strong>
      </div>
      {sortedTimeblocks.map(({ timeblockId, from, to }) => (
        <div key={timeblockId}>
          <Checkbox
            variant="selector"
            state="checked"
            onChange={() => onChange(timeblockId)}
            type="checkbox"
            value={timeblockId.toString()}
            checked={selectedTimeblockId === timeblockId}
            className="mb-3"
            id={`timeblock-${timeblockId}`}
          >
            <div className="flex items-center justify-between text-left">
              <span>{formatTimeInterval(from, to, "m")}</span>
            </div>
          </Checkbox>
        </div>
      ))}

      {hasNightTimeDelivery && (
        <div className="mt-4 text-xs text-center border-1.5 bg-highlightBG border-highlight rounded-lg">
          <p className="px-4 py-3">{intl.NIGHT_TIME_DELIVERY_WARNING}</p>
        </div>
      )}
    </div>
  );
};
